import React, { useEffect, useState } from 'react';

const CardPlayArea = ({ currentTrick, lastCompletedTrick, players, animatingCard }) => {
  const [displayedCards, setDisplayedCards] = useState([]);

  useEffect(() => {
    console.log('CardPlayArea - currentTrick:', currentTrick, 'lastCompletedTrick:', lastCompletedTrick);
    
    // Use current trick if available, otherwise show last completed trick briefly
    if (currentTrick && currentTrick.length > 0) {
      console.log('Displaying current trick with', currentTrick.length, 'cards');
      setDisplayedCards(currentTrick);
    } else if (lastCompletedTrick && lastCompletedTrick.length > 0) {
      console.log('Displaying last completed trick with', lastCompletedTrick.length, 'cards');
      setDisplayedCards(lastCompletedTrick);
      // Clear last completed trick after 3 seconds
      const timeout = setTimeout(() => {
        console.log('Clearing completed trick');
        setDisplayedCards([]);
      }, 3000);
      return () => clearTimeout(timeout);
    } else {
      setDisplayedCards([]);
    }
  }, [currentTrick, lastCompletedTrick]);

  // Position cards in a diamond/cross pattern around center
  const getCardPosition = (seatIndex) => {
    const positions = {
      0: { bottom: '15%', left: '50%', transform: 'translateX(-50%)' }, // You - bottom center
      1: { top: '50%', right: '15%', transform: 'translateY(-50%)' }, // Player 2 - right center
      2: { top: '15%', left: '50%', transform: 'translateX(-50%)' }, // Partner - top center
      3: { top: '50%', left: '15%', transform: 'translateY(-50%)' } // Player 4 - left center
    };
    return positions[seatIndex] || positions[0];
  };

  return (
    <div className="absolute inset-0 pointer-events-none z-40">
      {/* Center Play Area */}
      <div className="absolute inset-0 flex items-center justify-center">
        {/* Circular table center */}
        <div className="w-64 h-64 rounded-full bg-green-800/30 border-4 border-green-600/50 flex items-center justify-center">
          {displayedCards.length === 0 && (
            <div className="text-white/30 text-center">
              <p className="text-sm font-semibold">Play Area</p>
              <p className="text-xs">Cards will appear here</p>
            </div>
          )}
        </div>
      </div>

      {/* Played Cards with Animation */}
      {displayedCards.map((play, index) => {
        // Handle different property names for seat (seat, playerSeat, etc.)
        const seatIndex = play.seat !== undefined ? play.seat : (play.playerSeat !== undefined ? play.playerSeat : index);
        const position = getCardPosition(seatIndex);
        const isAnimating = animatingCard?.seat === seatIndex && animatingCard?.cardIndex === index;
        
        console.log('Rendering card', index, 'for seat', seatIndex, 'card:', play.card);
        
        return (
          <div
            key={`card-${seatIndex}-${index}-${play.card?.value}${play.card?.suit}`}
            className={`absolute z-${10 + index} ${isAnimating ? 'animate-card-play' : ''}`}
            style={{
              ...position,
              transition: isAnimating ? 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none',
              animation: isAnimating ? 'cardPlay 0.6s ease-out' : 'none',
              zIndex: 40 + index
            }}
          >
            <div className={`bg-white rounded-xl shadow-2xl p-4 min-w-[90px] border-4 ${
              seatIndex === 0 ? 'border-emerald-400' :
              seatIndex === 1 ? 'border-red-400' :
              seatIndex === 2 ? 'border-blue-400' : 'border-yellow-400'
            } ${isAnimating ? 'scale-110' : 'scale-100'}`}>
              <div className={`text-4xl text-center font-bold ${play.card.color === 'red' ? 'text-red-600' : 'text-black'}`}>
                {play.card.suit}
              </div>
              <div className={`text-2xl text-center font-bold mt-1 ${play.card.color === 'red' ? 'text-red-600' : 'text-black'}`}>
                {play.card.value}
              </div>
              {/* Player name badge */}
              <div className="absolute -bottom-7 left-1/2 transform -translate-x-1/2 bg-black/90 text-white px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap shadow-lg">
                {players[seatIndex]?.name || `Player ${seatIndex + 1}`}
              </div>
            </div>
          </div>
        );
      })}

      {/* CSS Animation */}
      <style jsx>{`
        @keyframes cardPlay {
          0% {
            opacity: 0;
            transform: scale(0.3) translateY(200px);
          }
          50% {
            opacity: 1;
            transform: scale(1.2);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-card-play {
          animation: cardPlay 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
      `}</style>
    </div>
  );
};

export default CardPlayArea;
